export const GET_ACCOUNTS = "GET_ACCOUNTS";
export const GOT_ACCOUNTS = "GOT_ACCOUNTS";
export const GOT_ACCOUNTS_ERROR = "GOT_ACCOUNTS_ERROR";

export const GET_ACCOUNT = "GET_ACCOUNT";
export const GOT_ACCOUNT = "GOT_ACCOUNT";
export const GOT_ACCOUNT_ERROR = "GOT_ACCOUNT_ERROR";
